import React, { useState } from 'react'
import { Pressable, Text, View } from 'react-native'

import { IMAGE } from '@ui-kit/assets/images/index.native'
import Icon from '@ui-kit/components/Icon'
import { tableContent } from '@ui-kit/components/Table/TableCategoryAccordionContent/styles'
import TableRowContentValue from '@ui-kit/components/Table/TableRowContentValue/index.native'
import type { TableRow } from '@ui-kit/components/Table/types'

interface Props {
  rowContent: TableRow
  isFirst: boolean
}

const TableCategoryAccordionContent = (props: Props) => {
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(
    props.rowContent.isExpandedByDefault
  )
  const { row, titleContainer, descriptionTitleContainer, descriptionTitle, description } =
    tableContent({
      isFirst: props.isFirst,
    })

  return (
    <View className={row()} key={props.rowContent.key}>
      <View className={titleContainer()}>
        <Pressable
          className={descriptionTitleContainer()}
          onPress={() => setIsDescriptionExpanded(!isDescriptionExpanded)}
        >
          <Text className={descriptionTitle()}>{props.rowContent.title}</Text>
          {props.rowContent.description && (
            <Icon
              imgSrc={
                isDescriptionExpanded
                  ? IMAGE.icons.xsmall.action.circleInfoActive_16
                  : IMAGE.icons.xsmall.action.circleInfoDisabled_16
              }
            />
          )}
        </Pressable>
        {/* description could contain HTML elements */}
        {/* Ticket: https://hellogetsafe.atlassian.net/browse/BX-730 */}
        {props.rowContent.description && isDescriptionExpanded && (
          <Text className={description()}>{props.rowContent.description}</Text>
        )}
      </View>
      {/* table row data (string or boolean) */}
      {props.rowContent.rowData.map((rowContentValue) => (
        <TableRowContentValue
          key={rowContentValue.key}
          rowContentValue={rowContentValue}
          isDescriptionExpanded={isDescriptionExpanded}
        />
      ))}
    </View>
  )
}

export default TableCategoryAccordionContent
